import React, { useEffect, useState } from 'react'
import './ProviderHoldsQuickView.scss'
import 'src/components/common/CardIssues/CardIssues.scss'
import CardIssues from 'src/components/common/CardIssues/CardIssues'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setProviderHoldTabOpened } from '../../../../redux/providerHold/providerHoldSlice'
import { COLLECTOR_URL } from '../../../../apiHelper/apiRoute/collector'
import { getCollector } from '../../../../apiHelper/collectorApi'
import { CSpinner } from '@coreui/react-pro'

export default function ProviderHoldsQuickView() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)
  const [providerHoldData, setProviderHoldData] = useState()
  const [issuesCount, setIssuesCount] = useState(0)

  useEffect(() => {
    const getProviderHoldData = async () => {
      try {
        setLoading(true)
        const url = COLLECTOR_URL.GET_PROVIDER_HOLD_DATA
        let res = await getCollector(
          url
            .replace('{startIndex}', '0')
            .replace('{recordCount}', '3')
            .replace('{scope}', 'practice'),
        )
        if (res?.status === 'SUCCESS') {
          setProviderHoldData(res?.data.result)
          setIssuesCount(res?.data.total)
        }
        setLoading(false)
      } catch (error) {
        console.error('Error fetching dashboard provider holds:', error)
      }
    }
    getProviderHoldData()
  }, [dispatch])

  return (
    <div className="providerholds-container">
      <div className="header-container">
        <span className="providerholds-heading">Provider Holds</span>
        <div className="notification-icon-container">
          <i
            className="fa-solid fa-bell"
            style={{ color: ' var(--purple_800)', marginRight: '4px' }}
          ></i>
          <div className="notification-number">{issuesCount}</div>
        </div>
      </div>
      <div className="subheading-container pt-2">
        {/*  For spacing */}
        <span className="providerholds-subheading"></span>
        {providerHoldData?.length > 0 && (
          <span
            className="provider-seeall-link"
            onClick={() => {
              dispatch(setProviderHoldTabOpened())
              navigate('/providerhold')
            }}
          >
            See Provider Holds
          </span>
        )}
      </div>
      {providerHoldData?.length > 0 ? (
        providerHoldData.slice(0, 3).map((item, index) => (
          <div key={index}>
            <CardIssues item={item} />
          </div>
        ))
      ) : (
        <div className="noresult-found">
          {loading ? <CSpinner /> : <p>No provider holds found</p>}
        </div>
      )}
    </div>
  )
}
